/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { HubSpotEnrollRequestFirstname } from './hubSpotEnrollRequestFirstname';
import type { HubSpotEnrollRequestLastname } from './hubSpotEnrollRequestLastname';
import type { HubSpotEnrollRequestEnrollments } from './hubSpotEnrollRequestEnrollments';
import type { HubSpotEnrollRequestExternalProductIds } from './hubSpotEnrollRequestExternalProductIds';
import type { HubSpotEnrollRequestExternalStudentId } from './hubSpotEnrollRequestExternalStudentId';
import type { HubSpotEnrollRequestHubspotContactId } from './hubSpotEnrollRequestHubspotContactId';

/**
 * Method 1 enrollment: per-row extras, Academy5 id, welcome-mail toggle.

Send ``enrollments`` (preferred) **or** legacy ``externalProductIds``, never both.
``sendWelcomeEmail`` defaults false — Railway still mails if left true.
 */
export interface HubSpotEnrollRequest {
  /** Student email address (Primary ID) */
  email: string;
  /** Student's first name (required for initial enrollment) */
  firstname?: HubSpotEnrollRequestFirstname;
  /** Student's last name (required for initial enrollment) */
  lastname?: HubSpotEnrollRequestLastname;
  /** Courses to enroll, each with optional extraModuleIds on that row */
  enrollments?: HubSpotEnrollRequestEnrollments;
  /** Legacy flat SKU list (no extras). Forbidden when enrollments is set. */
  externalProductIds?: HubSpotEnrollRequestExternalProductIds;
  /** Tenant-unique Academy5 / external student id */
  externalStudentId?: HubSpotEnrollRequestExternalStudentId;
  /** If true, UserService.create sends credentials/welcome. Default false. */
  sendWelcomeEmail?: boolean;
  /** The HubSpot Deal ID for audit trail */
  hubspotDealId: string;
  /** The HubSpot Contact ID for reference */
  hubspotContactId?: HubSpotEnrollRequestHubspotContactId;
}
